import { useState } from "react"
import { Container, Row, Col, Form, Button } from "react-bootstrap"
import { useParams } from 'react-router-dom'
import { Link } from "react-router-dom"
import { ArrowRightCircle } from 'react-bootstrap-icons'
import 'animate.css';
import Menu from '../components/general/Menu';
import Footer from '../components/general/Footer';
import PasswordInput from '../components/general/PasswordInput';

export default function NotFoundPage() {
  const [password, setPassword] = useState('')
  const [passwordconfirm, setPasswordConfirm] = useState('')
  const [errmsg, setErrmsg] = useState('')
  const [saveLoading, setSaveLoading] = useState(false)
  const [messageColor, setMessageColor] = useState('text-danger')

  const url = process.env.REACT_APP_URL
  const params = useParams()
  const token = params.token

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveLoading(true);
    try {
      setErrmsg('')
      if (password !== passwordconfirm) {
        setMessageColor('text-danger')
        setErrmsg('Passwords do not match')
        setSaveLoading(false)
        return
      }
      const newPassword = password
      const response = await fetch(`${url}/reset/${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ newPassword })
      })
      const result = await response.json()
      console.log(response.status)
      if (response.status === 200) {
        setErrmsg(result.message)
        setMessageColor('text-success')
      }
      else {
        setMessageColor('text-danger')
        setErrmsg(result.message || result.Error || 'Password reset failed')
      }
    }
    catch (error) {
      console.log(error)
      setMessageColor('text-danger')
      setErrmsg(error)
    }
    setSaveLoading(false);
  }
  return (
    <section className='home'>
      <Menu />
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} xl={5} className="mb-60" >
              <div className="animate__animated animate__zoomIn">
                <Link to='/'>
                  <img
                    className='main-logo-img'
                    src={'/TMLogo.png'}
                    alt="Header Img"
                    style={{ cursor: 'pointer' }}
                  />
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} xl={7}>
              <div className="animate__animated animate__fadeIn">
                <h1 className="animate__animated animate__slideInUp"><span className="bold">RESET PASSWORD</span></h1>
                <p><br /><br /></p>
                <div className="border-top-bottom subtitle mb-30 mt-30 animate__animated animate__slideInUp">
                  <Form onSubmit={handleSubmit} className="py-4">
                    <PasswordInput
                      className="formInput mb-3"
                      placeholder="New Password*"
                      aria-label="New Password*"
                      name="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <PasswordInput
                      className="formInput mb-3"
                      placeholder="Confirm Password*"
                      aria-label="Confirm Password*"
                      name="passwordConfirm"
                      value={passwordconfirm}
                      onChange={e => setPasswordConfirm(e.target.value)}
                    />
                    {errmsg && <p className={messageColor}>{String(errmsg)}</p>}
                    <div className="text-end">
                      <Button variant="primary" type="submit" disabled={saveLoading}>
                        {saveLoading ? 'Saving password ...' : 'Save Changes'}
                      </Button>
                    </div>
                  </Form>
                </div>

                <Link to='/' className="mb-30 mt-30 animate__animated animate__slideInUp">Let's go home <ArrowRightCircle size={25} /></Link>
              </div>
            </Col>
          </Row>
        </Container>
      <Footer />
    </section>
  )
}